import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// 차량 결제(배분) 추적 모달 — 계약금/자동배분/잔금 각 금액·날짜·출처 입금 표시
// 백엔드: GET /cars/:id/allocations

var TXT = {
  title2: ' \u2014 \uACB0\uC81C \uB0B4\uC5ED', //  — 결제 내역
  close: '\u2715', // ✕
  loading: '\uBD88\uB7EC\uC624\uB294 \uC911...', // 불러오는 중...
  empty: '\uBC30\uBD84 \uB0B4\uC5ED \uC5C6\uC74C (\uACC4\uC57D\uAE08\u00B7\uC790\uB3D9\uBC30\uBD84 \uC5C6\uC74C)', // 배분 내역 없음 (계약금·자동배분 없음)
  loadError: '\uB85C\uB4DC \uC2E4\uD328', // 로드 실패
  tContract: '\uD83D\uDCDD \uACC4\uC57D\uAE08', // 📝 계약금
  tAuto: '\uD83C\uDFAF \uC790\uB3D9\uBC30\uBD84', // 🎯 자동배분
  tManual: '\uD83D\uDCB0 \uC794\uAE08', // 💰 잔금
  tLegacy: '\u26A0\uFE0F legacy', // ⚠️ legacy
  srcContract: '\uD604\uC7A5\uACC4\uC57D\uC11C \uACC4\uC57D\uAE08', // 현장계약서 계약금
  srcDeposit: ' \uC785\uAE08', //  입금
  allocOn: '\uBC30\uBD84\uC77C ', // 배분일 
  sumSell: '\uD310\uB9E4\uAC00', // 판매가
  sumReceived: '\uC218\uB839 \uD569\uACC4', // 수령 합계
  sumRemaining: '\uC794\uAE08', // 잔금
  paid: '\uC644\uB0A9 \u2713', // 완납 ✓
  won: '\uC6D0', // 원
  noSrc: '\uCD9C\uCC98 \uC785\uAE08 \uC5C6\uC74C', // 출처 입금 없음
};

function fmtKrw(won){return (won||0).toLocaleString()+TXT.won}
function dstr(s){return s?String(s).slice(0,10):''}

function typeStyle(t){
  if(t==='contract')return {tag:TXT.tContract,bg:'#eff6ff',border:'#bfdbfe',color:'#1e40af',amt:'#2563eb'};
  if(t==='auto_fifo')return {tag:TXT.tAuto,bg:'#ecfeff',border:'#a5f3fc',color:'#0e7490',amt:'#0891b2'};
  if(t==='legacy')return {tag:TXT.tLegacy,bg:'#fefce8',border:'#fde68a',color:'#92400e',amt:'#ca8a04'};
  return {tag:TXT.tManual,bg:'#f0fdf4',border:'#bbf7d0',color:'#166534',amt:'#16a34a'};
}

function CarPaymentTraceModal(props){
  var carId=props.carId;
  var carNo=props.carNo||('#'+carId);
  var onClose=props.onClose;
  var showToast=props.showToast;
  var [loading,setLoading]=useState(false);
  var [data,setData]=useState(null);

  useEffect(function(){
    if(!carId)return;
    setLoading(true);
    authFetch(API+'/cars/'+carId+'/allocations').then(function(r){return r.json()}).then(function(d){
      setLoading(false);
      if(d&&d.allocations){setData(d)}else{showToast&&showToast((d&&d.error)||TXT.loadError,'err')}
    }).catch(function(){setLoading(false);showToast&&showToast(TXT.loadError,'err')});
  },[carId]);

  var overlay={position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:2100,display:'flex',alignItems:'center',justifyContent:'center',padding:20};
  var modal={background:'#fff',borderRadius:12,width:'100%',maxWidth:480,maxHeight:'85vh',display:'flex',flexDirection:'column',overflow:'hidden'};
  var header={padding:'14px 18px',borderBottom:'1px solid #e2e8f0',display:'flex',justifyContent:'space-between',alignItems:'center'};
  var bodyS={padding:'14px 18px',overflowY:'auto',flex:1};

  var allocs=(data&&data.allocations)||[];
  var sell=(data&&data.sellPrice)||0;
  var received=(data&&data.totalAllocated)||0;
  var remaining=sell-received;

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={function(e){e.stopPropagation()}}>
        <div style={header}>
          <div style={{fontSize:15,fontWeight:700,color:'#0f172a'}}>{carNo + TXT.title2}</div>
          <button onClick={onClose} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#64748b'}}>{TXT.close}</button>
        </div>
        <div style={bodyS}>
          {loading&&<div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12}}>{TXT.loading}</div>}
          {!loading&&allocs.length===0&&<div style={{padding:24,textAlign:'center',color:'#94a3b8',fontSize:12,background:'#f8fafc',borderRadius:8}}>{TXT.empty}</div>}
          {!loading&&allocs.map(function(a,idx){
            var st=typeStyle(a.type);
            var hasSrc=a.depositId&&a.depositDate;
            return (
              <div key={idx} style={{padding:'9px 11px',marginBottom:6,background:st.bg,border:'1px solid '+st.border,borderRadius:8}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:8}}>
                  <span style={{fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:10,background:'#fff',color:st.color,border:'1px solid '+st.border,whiteSpace:'nowrap'}}>{st.tag}</span>
                  <span style={{fontSize:14,fontWeight:800,color:st.amt}}>{'+ '+fmtKrw(a.amount)}</span>
                </div>
                <div style={{fontSize:11,color:'#475569',marginTop:5,display:'flex',flexWrap:'wrap',gap:8,alignItems:'center'}}>
                  {a.allocatedAt&&<span style={{color:'#64748b'}}>{TXT.allocOn + dstr(a.allocatedAt)}</span>}
                  {hasSrc&&<span style={{fontWeight:600,color:st.color,background:'#fff',padding:'1px 7px',borderRadius:8,border:'1px solid '+st.border}}>{'← ' + dstr(a.depositDate) + TXT.srcDeposit + (a.depositAmount!=null?(' (' + fmtKrw(a.depositAmount) + ')'):'')}</span>}
                  {a.type==='contract'&&!hasSrc&&<span style={{color:'#94a3b8'}}>{TXT.srcContract}</span>}
                  {!hasSrc&&a.type!=='contract'&&a.depositId==null&&<span style={{color:'#cbd5e1'}}>{TXT.noSrc}</span>}
                </div>
                {hasSrc&&a.depositMemo&&<div style={{fontSize:10,color:'#94a3b8',marginTop:3,fontStyle:'italic'}}>{'"' + a.depositMemo + '"'}</div>}
              </div>
            );
          })}
          {!loading&&data&&(
            <div style={{marginTop:10,padding:'10px 12px',background:'#f1f5f9',borderRadius:8,fontSize:12}}>
              {sell>0&&<div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}><span style={{color:'#64748b'}}>{TXT.sumSell}</span><span style={{fontWeight:700,color:'#1e293b'}}>{fmtKrw(sell)}</span></div>}
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}><span style={{color:'#64748b'}}>{TXT.sumReceived}</span><span style={{fontWeight:700,color:'#2563eb'}}>{fmtKrw(received)}</span></div>
              {sell>0&&<div style={{display:'flex',justifyContent:'space-between',borderTop:'1px solid #e2e8f0',paddingTop:4,marginTop:2}}><span style={{color:'#64748b',fontWeight:600}}>{TXT.sumRemaining}</span><span style={{fontWeight:800,color:remaining<=0?'#16a34a':'#d97706'}}>{remaining<=0?TXT.paid:fmtKrw(remaining)}</span></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CarPaymentTraceModal;
